export const iconFontAwesomeBuildingsTentArrowLeftRight = (
	<i className="fa-solid fa-tent-arrow-left-right"></i>
);
